/* eslint-disable */
import { grpc } from "@injectivelabs/grpc-web";
import { BrowserHeaders } from "browser-headers";
import _m0 from "protobufjs/minimal.js";
import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination.js";
import { TokenPair } from "./erc20.js";
import { Params } from "./params.js";
export const protobufPackage = "injective.erc20.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return QueryParamsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
export const QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    create(base) {
        return QueryParamsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = (object.params !== undefined && object.params !== null)
            ? Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function createBaseQueryAllTokenPairsRequest() {
    return { pagination: undefined };
}
export const QueryAllTokenPairsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllTokenPairsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    create(base) {
        return QueryAllTokenPairsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryAllTokenPairsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? PageRequest.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryAllTokenPairsResponse() {
    return { tokenPairs: [], pagination: undefined };
}
export const QueryAllTokenPairsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tokenPairs) {
            TokenPair.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllTokenPairsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenPairs.push(TokenPair.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenPairs: Array.isArray(object?.tokenPairs) ? object.tokenPairs.map((e) => TokenPair.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenPairs) {
            obj.tokenPairs = message.tokenPairs.map((e) => e ? TokenPair.toJSON(e) : undefined);
        }
        else {
            obj.tokenPairs = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    create(base) {
        return QueryAllTokenPairsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryAllTokenPairsResponse();
        message.tokenPairs = object.tokenPairs?.map((e) => TokenPair.fromPartial(e)) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? PageResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryTokenPairByDenomRequest() {
    return { bankDenom: "" };
}
export const QueryTokenPairByDenomRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bankDenom !== "") {
            writer.uint32(10).string(message.bankDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTokenPairByDenomRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bankDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { bankDenom: isSet(object.bankDenom) ? String(object.bankDenom) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.bankDenom !== undefined && (obj.bankDenom = message.bankDenom);
        return obj;
    },
    create(base) {
        return QueryTokenPairByDenomRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTokenPairByDenomRequest();
        message.bankDenom = object.bankDenom ?? "";
        return message;
    },
};
function createBaseQueryTokenPairByDenomResponse() {
    return { tokenPair: undefined };
}
export const QueryTokenPairByDenomResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tokenPair !== undefined) {
            TokenPair.encode(message.tokenPair, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTokenPairByDenomResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenPair = TokenPair.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { tokenPair: isSet(object.tokenPair) ? TokenPair.fromJSON(object.tokenPair) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.tokenPair !== undefined &&
            (obj.tokenPair = message.tokenPair ? TokenPair.toJSON(message.tokenPair) : undefined);
        return obj;
    },
    create(base) {
        return QueryTokenPairByDenomResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTokenPairByDenomResponse();
        message.tokenPair = (object.tokenPair !== undefined && object.tokenPair !== null)
            ? TokenPair.fromPartial(object.tokenPair)
            : undefined;
        return message;
    },
};
function createBaseQueryTokenPairByERC20AddressRequest() {
    return { erc20Address: "" };
}
export const QueryTokenPairByERC20AddressRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.erc20Address !== "") {
            writer.uint32(10).string(message.erc20Address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTokenPairByERC20AddressRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.erc20Address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { erc20Address: isSet(object.erc20Address) ? String(object.erc20Address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.erc20Address !== undefined && (obj.erc20Address = message.erc20Address);
        return obj;
    },
    create(base) {
        return QueryTokenPairByERC20AddressRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTokenPairByERC20AddressRequest();
        message.erc20Address = object.erc20Address ?? "";
        return message;
    },
};
function createBaseQueryTokenPairByERC20AddressResponse() {
    return { tokenPair: undefined };
}
export const QueryTokenPairByERC20AddressResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tokenPair !== undefined) {
            TokenPair.encode(message.tokenPair, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTokenPairByERC20AddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenPair = TokenPair.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { tokenPair: isSet(object.tokenPair) ? TokenPair.fromJSON(object.tokenPair) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.tokenPair !== undefined &&
            (obj.tokenPair = message.tokenPair ? TokenPair.toJSON(message.tokenPair) : undefined);
        return obj;
    },
    create(base) {
        return QueryTokenPairByERC20AddressResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTokenPairByERC20AddressResponse();
        message.tokenPair = (object.tokenPair !== undefined && object.tokenPair !== null)
            ? TokenPair.fromPartial(object.tokenPair)
            : undefined;
        return message;
    },
};
export class QueryClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.AllTokenPairs = this.AllTokenPairs.bind(this);
        this.TokenPairByDenom = this.TokenPairByDenom.bind(this);
        this.TokenPairByERC20Address = this.TokenPairByERC20Address.bind(this);
    }
    Params(request, metadata) {
        return this.rpc.unary(QueryParamsDesc, QueryParamsRequest.fromPartial(request), metadata);
    }
    AllTokenPairs(request, metadata) {
        return this.rpc.unary(QueryAllTokenPairsDesc, QueryAllTokenPairsRequest.fromPartial(request), metadata);
    }
    TokenPairByDenom(request, metadata) {
        return this.rpc.unary(QueryTokenPairByDenomDesc, QueryTokenPairByDenomRequest.fromPartial(request), metadata);
    }
    TokenPairByERC20Address(request, metadata) {
        return this.rpc.unary(QueryTokenPairByERC20AddressDesc, QueryTokenPairByERC20AddressRequest.fromPartial(request), metadata);
    }
}
export const QueryDesc = { serviceName: "injective.erc20.v1beta1.Query" };
export const QueryParamsDesc = {
    methodName: "Params",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryParamsRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryParamsResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryAllTokenPairsDesc = {
    methodName: "AllTokenPairs",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryAllTokenPairsRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryAllTokenPairsResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryTokenPairByDenomDesc = {
    methodName: "TokenPairByDenom",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryTokenPairByDenomRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryTokenPairByDenomResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryTokenPairByERC20AddressDesc = {
    methodName: "TokenPairByERC20Address",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryTokenPairByERC20AddressRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryTokenPairByERC20AddressResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc.Code.OK) {
                        resolve(response.message.toObject());
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function isSet(value) {
    return value !== null && value !== undefined;
}
export class GrpcWebError extends tsProtoGlobalThis.Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
